import '../helpers/funcs';
import Popup from './Popup';
import Loader from './Loader';
import Timer from './Timer';

class Bid {
    constructor(id) {
        this.id = id;
        this.lot = $('[data-bid][data-lot=' + this.id + ']');
    }

    increase() {
        window.LOTS[this.id].new_bid = Math.min(
            Math.max(
                parseInt(window.LOTS[this.id].new_bid) || 0,
                parseInt(window.LOTS[this.id].price)
            ) + parseInt(window.LOTS[this.id].step),
            parseInt(window.LOTS[this.id].price) * 1.1
        );
    }

    decrease() {
        window.LOTS[this.id].new_bid = Math.max(parseInt(window.LOTS[this.id].price), Math.max(parseInt(window.LOTS[this.id].new_bid) || 0, parseInt(window.LOTS[this.id].price)) - parseInt(window.LOTS[this.id].step));
    }

    change() {
        window.LOTS[this.id].new_bid = parseInt(this.lot.find('[data-bid-value]').val().replace(/\s/g, ''));
    }

    update() {
        this.lot.find('[data-bid-value]').removeClass('error');
        this.lot.find('[data-bid-value]').val(window.LOTS[this.id].new_bid);
    }

    bid() {
        if (! this.validate())
            return;

        var self = this;

        var loader = new Loader(this.lot);

        $.ajax({
            type: 'POST',
            url: '/api/lot/bid',
            data: {
                lot_id: this.id,
                price: window.LOTS[this.id].new_bid
            },
            success: r => {
                loader.stop();

                if (r.STATUS == 'OK') {
                    self.greet();
                    return;
                } else if (r.STATUS == 'INSUFFICIENT_BALANCE') {
                    $('.low-balance-link').attr('href', r.LINK)
                    Popup.show('#popup-low-balance')
                    return
                } else if (r.STATUS == 'ERROR') {
                    Popup.error(`На сервере произошла ошибка. ${r.MESSAGE}`);
                }

                Popup.error('На сервере произошла ошибка. Пожалуйста, повторите запрос позже.');
            },
            error: e => {
                loader.stop();

                var r = e.responseJSON;
                if (r.MESSAGE)
                    Popup.error(r.MESSAGE);
            }
        });
    }

    validate() {
        // if (Timer.getTimestamp(window.LOTS[this.id].dt_end) - Date.parse(new Date()) < 1000) {

        //     Popup.error('Лот завершен.');

        //     return false;
        // }

        if (window.LOTS[this.id].new_bid == undefined || parseInt(window.LOTS[this.id].new_bid) < parseInt(window.LOTS[this.id].price) + parseInt(window.LOTS[this.id].step)) {
            this.lot.find('[data-bid-value]').addClass('error');

            Popup.error('Ваша ставка не принята. Необходимо увеличить ставку минимум на один шаг аукциона.');

            return false;
        }

        if (parseInt(window.LOTS[this.id].new_bid) > parseInt(window.LOTS[this.id].price) * 1.1) {
            this.lot.find('[data-bid-value]').addClass('error');

            Popup.error('Ваша ставка не принята. Ставка не может превышать 10% от текущей стоимости.');

            return false;
        }

        return true;
    }

    greet() {
        this.updateCurrentPrice();
        this.updateBidStatus();
        this.updateNextBidValue();
        delete window.LOTS[this.id].new_bid;
    }

    updateCurrentPrice() {
        this.lot.find('[data-bid-price]').text(parseInt(window.LOTS[this.id].new_bid).format() + ' руб.');
        window.LOTS[this.id].price = parseInt(window.LOTS[this.id].new_bid);

        // this.lot.find('[data-bid-value]').removeClass('error');
        // this.lot.find('[data-bid-value]')[0].value = '';
    }

    updateBidStatus() {
        let status = this.lot.find('[data-bid-status]');
        status.removeClass('bid-status_none');
        status.removeClass('bid-status_beaten');
        status.addClass('bid-status_lead');
        status.children().text('Вы лидируете');
        window.LOTS[this.id].winner = true;
    }

    updateNextBidValue() {
        this.lot.find('[data-bid-next-value]').text(parseInt(window.LOTS[this.id].new_bid + parseInt(window.LOTS[this.id].step)).format());
    }
}

export default Bid;
